import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "exam-quiz-container"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_quiz_checkable_text_question = _resolveComponent("quiz-checkable-text-question");
  const _component_quiz_blanks_question = _resolveComponent("quiz-blanks-question");
  const _component_quiz_pairs_matching_question = _resolveComponent("quiz-pairs-matching-question");
  const _component_quiz_sorting_question = _resolveComponent("quiz-sorting-question");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_ctx.question ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_ctx.isCheckableQuestion(_ctx.question) ? (_openBlock(), _createBlock(_component_quiz_checkable_text_question, {
    key: 0,
    class: "exam-quiz-question",
    question: _ctx.question,
    "question-custom-label": _ctx.getQuestionLabel(_ctx.question),
    selected: _ctx.userAnswers(_ctx.question),
    onSelectionChange: _ctx.onSelectionChange
  }, null, 8, ["question", "question-custom-label", "selected", "onSelectionChange"])) : _ctx.isBlanksQuestion(_ctx.question) ? (_openBlock(), _createBlock(_component_quiz_blanks_question, {
    key: 1,
    class: "exam-quiz-question",
    question: _ctx.question,
    "question-custom-label": _ctx.getQuestionLabel(_ctx.question),
    "user-blanks-answers": _ctx.userBlanksAnswers,
    onBlankAnswerUpdate: _ctx.onBlankAnswerUpdate
  }, null, 8, ["question", "question-custom-label", "user-blanks-answers", "onBlankAnswerUpdate"])) : _ctx.isPairsMatchingQuestion(_ctx.question) ? (_openBlock(), _createBlock(_component_quiz_pairs_matching_question, {
    key: 2,
    class: "exam-quiz-question",
    question: _ctx.question,
    "question-custom-label": _ctx.getQuestionLabel(_ctx.question),
    "user-pairs-matching": _ctx.userPairsMatching,
    onUserPairMatchingUpdate: _ctx.onPairMatchingUpdate
  }, null, 8, ["question", "question-custom-label", "user-pairs-matching", "onUserPairMatchingUpdate"])) : _ctx.isSortingQuestion(_ctx.question) ? (_openBlock(), _createBlock(_component_quiz_sorting_question, {
    key: 3,
    class: "exam-quiz-question",
    question: _ctx.question,
    "question-custom-label": _ctx.getQuestionLabel(_ctx.question),
    "user-items-sorting": _ctx.userItemsSorting,
    onUserItemsSortingUpdate: _ctx.onItemsSortingUpdate
  }, null, 8, ["question", "question-custom-label", "user-items-sorting", "onUserItemsSortingUpdate"])) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true)]);
}